import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBContainer,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,} from 'mdbreact'; */
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";
import AddEditOutsourcedItem from "../Administrator/AddEditOutsourcedItem";
import CreatableSelect from "react-select/creatable";
const AddEditOutsourcedItemNew = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: "",
    deleted: false,
    usertoken: sessionStorage.getItem("msal.uc"),
    itemcode: {
      value: "0",
      label: "Please select a service or item",
      outsourced: false,
      itemcategorycode: "2",
      sellingprice: 0,
    },
    quantity: 1,
    parentcode: props.parentcode,
    sellingprice: 0,
    itemcategory: { value: "2", label: "Goods" },
    outsourced: true,
  });

  const [passwordShown, setPasswordShown] = useState(false);

  const [disabledClass, setDisabledClass] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    saveitem();
  }

  const [itemcategoryoptions, setitemcategoryoptions] = useState([]);
  const getoutsourceditemcategoryoptions = () => {
    Axios.get(props.apiServer + "/getoutsourceditemcategoryoptions", bearer)
      .then((res) => {
        setitemcategoryoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalCustomerQuickAddOption, showCustomerQuickAddOption] =
    useState(false);
  const toggleCustomerQuickAddOption = () => {
    getitemsservicesoptions();
    showCustomerQuickAddOption(!modalCustomerQuickAddOption);
  };
  const [modalCustomerOption, showCustomerOption] = useState(false);
  const toggleCustomerOption = () => {
    getitemsservicesoptions();
    showCustomerOption(!modalCustomerOption);
  };

  const loaditemdetails = () => {
    Axios.get(
      props.apiServer + "/loadrecommendationdetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,
            quantity: res.data.quantity,
            deleted: res.data.deleted,

            itemcode: {
              value: res.data.itemcode,
              label: res.data.itemdescription,
            },
            itemcategory: {
              value: res.data.itemcategorycode,
              label: res.data.itemcategory,
            },
            sellingprice: res.data.sellingprice,
            outsourced: res.data.outsourced,
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const saveitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savesalesoutsourced", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          // toast.info(res.data.message, {
          //   closeButton: false,
          // });
          if (props.code === "new") {
            props.refreshGrid("Record successfully saved!");
            props.toggleModal();
          }
          // props.refreshGrid();
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const deleteitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/deleteitem", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          // props.refreshGrid();

          toast.info(res.data.message, {
            closeButton: false,
          });
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  const [itemsservicesoptions, setitemsservicesoptions] = useState([]);
  const getitemsservicesoptions = () => {
    Axios.get(props.apiServer + "/getitemsservicesoutsourcedoptions", bearer)
      .then((res) => {
        setitemsservicesoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useMountEffect(getitemsservicesoptions);
  useMountEffect(getoutsourceditemcategoryoptions);
  useMountEffect(loaditemdetails);

  const [itemCategoryCode, setItemCategoryCode] = useState("2");

  useEffect(() => {
    if (frm.code !== "") {
      return;
    }
    if (frm.itemcode === null) {
      setValues({
        ...frm,
        itemcategory: {
          value: "2",
          label: "Goods",
        },
        outsourced: true,
        sellingprice: 0,
      });
      return;
    }
    // console.log(frm.itemcode);
    // console.log(frm);
    // console.log(frm.itemcode.itemcategorycode);
    if (frm.itemcode.__isNew__ === true) {
      setValues({
        ...frm,
        itemcategory: {
          value: "2",
          label: "Goods",
        },
        outsourced: true,
        sellingprice: 0,
      });
      return;
    }

    setValues({
      ...frm,
      itemcategory: {
        value: frm.itemcode.itemcategorycode,
        label: frm.itemcode.itemcategory,
      },
      outsourced: true,
      sellingprice: frm.itemcode.sellingprice,
    });
  }, [frm.itemcode]);
  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="12">
            {" "}
            {props.code === "new" ? (
              <></>
            ) : (
              <>
                <h5
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="display-5 dark-grey-text ml-1 pt-3"
                >
                  Edit Recommendation
                </h5>
              </>
            )}
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="12">
                  <label className="grey-text">
                    <small>&nbsp;Item /Service</small>
                  </label>
                  <br />
                  <CreatableSelect
                    isClearable
                    value={frm.itemcode}
                    onChange={handleChange("itemcode")}
                    // onInputChange={this.handleInputChange}
                    options={itemsservicesoptions}
                    required
                  />
                  {/* <Select
                    placeholderText="Select Item / Service"
                    isSearchable
                    value={frm.itemcode}
                    onChange={handleChange("itemcode")}
                    options={itemsservicesoptions}
                    required
                    
                  /> */}

                  <div className="invalid-feedback ">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>

                  <br />
                </MDBCol>
                {/* <MDBCol md="4" className="ml-0 pr-0 pt-4">
                  <MDBBtn
                    size="sm"
                    onClick={toggleCustomerQuickAddOption}
                    className="grey lighten-5 brown-text"
                  >
                    <MDBIcon icon="plus" />
                  </MDBBtn>
                 
                </MDBCol> */}
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.quantity}
                    id="quantity"
                    label="Qty"
                    type="number"
                    onChange={updateField}
                    disabled={disabledClass}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.sellingprice}
                    id="sellingprice"
                    label="Price"
                    type="number"
                    onChange={updateField}
                    // disabled={disabledClass}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              {frm.itemcode === null ? (
                <>
                  {/* OUTSOURCED */}

                  <MDBRow>
                    <MDBCol md="8">
                      <label className="grey-text">
                        <small>&nbsp;Item Category</small>
                      </label>
                      <br />

                      <Select
                        placeholderText="Select Item Category"
                        isSearchable
                        value={frm.itemcategory}
                        onChange={handleChange("itemcategory")}
                        options={itemcategoryoptions}
                        required
                      />

                      <div className="invalid-feedback ">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                      <br />
                    </MDBCol>
                  </MDBRow>
                </>
              ) : (
                <>
                  {frm.itemcode.__isNew__ === true ? (
                    <>
                      {" "}
                      {/* OUTSOURCED */}
                      <MDBRow>
                        <MDBCol md="8">
                          <label className="grey-text">
                            <small>&nbsp;Item Category</small>
                          </label>
                          <br />

                          <Select
                            placeholderText="Select Item Category"
                            isSearchable
                            value={frm.itemcategory}
                            onChange={handleChange("itemcategory")}
                            options={itemcategoryoptions}
                            required
                          />

                          <div className="invalid-feedback ">
                            This field is required!
                          </div>
                          <div className="valid-feedback"></div>

                          <br />
                        </MDBCol>
                      </MDBRow>
                    </>
                  ) : (
                    <>
                      {/* EXISTING */}

                      <MDBRow>
                        <MDBCol md="8">
                          <label className="grey-text">
                            <small>&nbsp;Item Category</small>
                          </label>
                          <br />

                          <Select
                            placeholderText="Select Item Category"
                            isSearchable
                            value={frm.itemcategory}
                            onChange={handleChange("itemcategory")}
                            options={itemcategoryoptions}
                            isDisabled={true}
                            className="black-text font-weight-bold"
                          />

                          <br />
                        </MDBCol>
                      </MDBRow>
                    </>
                  )}
                </>
              )}
              <MDBRow>
                <MDBCol md="12">
                  <MDBInput
                    id="outsourced"
                    label="Outsourced"
                    labelClass="font-weight-bold red-text"
                    type="checkbox"
                    checked={frm.outsourced}
                    onChange={updateField}
                    disabled={true}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  <MDBInput
                    id="deleted"
                    label="Deleted"
                    labelClass="font-weight-bold red-text"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="6">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>{" "}
                  {props.code === "new" ? (
                    <MDBBtn
                      className="cloudy-knoxville-gradient blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      {/* <MDBModal
        backdrop={false}
        isOpen={modalCustomerOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          className="cloudy-knoxville-gradient"
          toggle={toggleCustomerOption}
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Inventory Items Dropdown Management
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <Items
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quicktool={"yes"}
            toggleModal2={toggleCustomerOption}
          />
        </MDBModalBody>
      </MDBModal> */}
      <MDBModal
        backdrop={false}
        isOpen={modalCustomerQuickAddOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleCustomerQuickAddOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Outsourced Charge
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          {/* <AddEditOutsourcedItem
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleCustomerQuickAddOption}
            itemcode={""}
            toggleModal={props.toggleAddEdit}
            refreshGrid={props.refreshGrid}
          /> */}
        </MDBModalBody>
      </MDBModal>
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditOutsourcedItemNew;
